import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { ref, SetupContext } from "@vue/composition-api";

export const useDrinkAlerts = (context: SetupContext) => {
  const {
    getIsBingeDrinker,
    getIsDangerousToHealth,
    getIsLowRiskBingeDrinker
  } = findScoreGetters(context.root.$store);

  const isBingeDrinker = getIsBingeDrinker();
  const isLowRiskBingeDrinker = getIsLowRiskBingeDrinker();

  let showDangerousToHealthModal = ref(getIsDangerousToHealth().value);

  const hideModal = () => {
    showDangerousToHealthModal.value = false;
  };

  return {
    isBingeDrinker,
    isLowRiskBingeDrinker,
    showDangerousToHealthModal,
    hideModal
  };
};
